import { Box, Typography } from "@mui/material";
import React from "react";
import MarqueeHorizontal, { MarqueeItemAlt } from "../UI/MarqueeHorizontal";
import MHButton from "../Common/Button/MHButton";
import LandingTouchDialog from "./LandingTouchDialog";

type Props = {};

const HeroSection = (props: Props) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Box px={{ xs: 4, sm: 10 }} py={{ xs: 2, sm: 4 }}>
        <Box
          sx={{
            borderRadius: "12px",
            position: "relative",
            height: { xs: "100%", sm: "621px" },
            overflow: "hidden",
          }}
        >
          <Box>
            <img
              src="https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg"
              alt="Landing"
              className="md:w-full h-96 mt-30 md:h-[621px] rounded-xl object-cover md:object-cover"
            />
          </Box>

          <Box
            className="absolute left-5 md:left-[50px] lg:left-[82px] z-50"
            sx={{
              top: { xs: "40%", sm: "50%" },
              transform: "translateY(-50%)",
            }}
          >
            <Typography
              variant="h2"
              fontSize={{ xs: "36px", sm: "50px", md: "80px" }}
              lineHeight={"90.5%"}
              letterSpacing={"-0.06em"}
              className="capitalize"
              color="white"
            >
              Advancing Care as <br /> Infrastructure for <br /> Africa's Growth
            </Typography>

            <Typography
              variant="subtitle2"
              fontSize={{ xs: "12px", sm: "13px", md: "18px" }}
              lineHeight={{ xs: "110%", sm: "169%" }}
              letterSpacing={"0.02em"}
              className="md:py-7 py-4 lg:py-5 lg:w-[40%] md:w-[60%]"
              color="white"
            >
              Through policy, innovation, and community-led programs, we are
              building care systems that unlock opportunity for women and
              strengthen economies across Africa.
            </Typography>

            <Box className=" mx-auto flex gap-4 mt-1 md:mt-3">
              <MHButton
                sx={{
                  color: "primary.main", // sets text color
                  backgroundColor: "secondary.main", // optional
                  borderRadius: "36px",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "primary.main", // sets text color
                  },
                }}
                className="w-fit md:w-[200px] h-8 md:h-[48px] font-areaExt text-[8px] md:text-xs"
                // endIcon={<PlusIcon />}
                onClick={() => window.location.replace("/focus")}
              >
                Explore Our Work{" "}
              </MHButton>
              <MHButton
                sx={{
                  color: "#fff", // sets text color
                  backgroundColor: "inherit", // optional
                  borderRadius: "36px",
                  borderColor: "#fff",
                  border: 2,
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "primary.main", // sets text color
                    borderColor: "primary.main",
                    border: 2,
                  },
                }}
                type="submit"
                className="   w-fit md:w-[160px] h-8 md:h-[48px] font-areaExt text-[8px] md:text-xs"
                // startIcon={<PlusIcon />}
                onClick={handleOpen}
              >
                Get In Touch
              </MHButton>
            </Box>
          </Box>

          {/* Web Slider */}
          <Box className="w-full h-fit absolute hidden lg:block rotate-90 topair md:top-[9%] lg:top-[40%] md:left-[45%] overflow-hidden overscroll-y-none gap-4">
            <MarqueeHorizontal continuous>
              <MarqueeItemAlt>
                <Typography
                  variant="h2"
                  fontSize={{ xs: "85.53px" }}
                  lineHeight={"100%"}
                  letterSpacing={"-0.06em"}
                  textTransform="uppercase"
                  color={"white"}
                >
                  {/* Career Caregiving Wellbeing Finances Lifestyle */}
                  Childcare Aging Care Women's Health Care Workforce Care
                  Economy
                </Typography>
              </MarqueeItemAlt>
            </MarqueeHorizontal>
          </Box>

          {/* Mobile Slider */}
          <Box className="w-full h-fit absolute bottom-4 z-30 block lg:hidden">
            <MarqueeHorizontal continuous>
              <MarqueeItemAlt>
                <Typography
                  variant="h2"
                  fontSize={{ xs: "46px" }}
                  lineHeight={"100%"}
                  letterSpacing={"-0.06em"}
                  textTransform="uppercase"
                  color={"white"}
                >
                  {/* Career Caregiving Wellbeing Finances Lifestyle */}
                  Childcare Aging Care Women's Health Care Workforce Care
                  Economy
                </Typography>
              </MarqueeItemAlt>
            </MarqueeHorizontal>
          </Box>
        </Box>
      </Box>

      <LandingTouchDialog open={open} onClose={handleClose} />
    </React.Fragment>
  );
};

export default HeroSection;
